import { cn } from '@/lib/utils/cn';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'pulse' | 'shimmer';
}

function Skeleton({ className, variant = 'pulse', ...props }: SkeletonProps) {
  return (
    <div
      className={cn(
        'rounded-md bg-muted',
        variant === 'pulse' && 'animate-pulse',
        variant === 'shimmer' && 'shimmer',
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
